import { render, staticRenderFns } from "./FormAssociantePaymentConfig.vue?vue&type=template&id=773f1b00"
import script from "./FormAssociantePaymentConfig.vue?vue&type=script&lang=js"
export * from "./FormAssociantePaymentConfig.vue?vue&type=script&lang=js"
import style0 from "./FormAssociantePaymentConfig.vue?vue&type=style&index=0&id=773f1b00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports